export default "__VITE_ASSET__MECV$z8v__"